import classNames from 'classnames';
import React from 'react';

import styles from './Alert.module.scss';

interface AlertProps {
  level: 'success' | 'danger';
}

const Alert: React.FC<AlertProps> = ({ children, level }) => (
  <div className={classNames(styles.alert, styles[level])}>
    {children}
  </div>
);

export default Alert;
